import { useState } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useT } from "@/lib/i18n";
import { fmtLap } from "@/lib/laps";

const tick = { fill: "#94A3B8", fontSize: 11, fontFamily: "JetBrains Mono" };

export const LapChart = ({ data, stats, prefix = "lap" }) => {
  const { t } = useT();
  const [param, setParam] = useState(data.param_names[0] || "");
  const [onlyUseful, setOnlyUseful] = useState(true);
  const laps = onlyUseful ? stats.useful : stats.valid;
  const points = [...laps].sort((a, b) => a.lap - b.lap).map((l) => ({ lap: l.lap, time: l.time, ...(param && { [param]: l.params[param] }) }));
  const btn = (active) => `px-2.5 py-1 font-mono text-[11px] uppercase border rounded-sm transition-colors duration-200 ${active ? "border-[#FFB800] text-[#FFB800] bg-[#FFB800]/10" : "border-[#282D3D] text-slate-400 hover:text-white"}`;
  return (
    <div data-testid={`${prefix}-chart`} className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-heading uppercase font-bold text-lg mr-2">{t("chart_laps")}</span>
        <span className="font-mono text-[10px] uppercase text-slate-500">{t("show_param")}</span>
        <button type="button" data-testid={`${prefix}-param-none`} onClick={() => setParam("")} className={btn(!param)}>{t("none")}</button>
        {data.param_names.map((n) => (
          <button type="button" key={n} data-testid={`${prefix}-param-${n}`} onClick={() => setParam(n)} className={btn(param === n)}>{n}</button>
        ))}
        <button type="button" data-testid={`${prefix}-useful-toggle`} onClick={() => setOnlyUseful(!onlyUseful)} className={`ml-auto ${btn(onlyUseful)}`}>≤107%</button>
      </div>
      <div className="h-[320px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 10, right: 10, bottom: 5, left: 0 }}>
            <CartesianGrid stroke="#282D3D" strokeDasharray="3 3" />
            <XAxis dataKey="lap" tick={tick} stroke="#282D3D" />
            <YAxis yAxisId="time" domain={["dataMin - 0.2", "dataMax + 0.2"]} tickFormatter={(v) => fmtLap(v, 1)} tick={tick} stroke="#282D3D" width={60} />
            {param && <YAxis yAxisId="param" orientation="right" domain={["auto", "auto"]} tick={tick} stroke="#282D3D" width={56} />}
            <Tooltip contentStyle={{ background: "#090A0F", border: "1px solid #282D3D", fontFamily: "JetBrains Mono", fontSize: 12 }}
              labelFormatter={(l) => `${t("lap_col")} ${l}`} formatter={(v, name) => (name === t("time_col") ? fmtLap(v, data.precision) : v)} />
            <Legend wrapperStyle={{ fontFamily: "JetBrains Mono", fontSize: 11 }} />
            <Line yAxisId="time" type="monotone" dataKey="time" name={t("time_col")} stroke="#10B981" strokeWidth={2} dot={{ r: 3 }} isAnimationActive={false} />
            {param && <Line yAxisId="param" type="monotone" dataKey={param} name={param} stroke="#FFB800" strokeWidth={1.5} strokeDasharray="5 3" dot={{ r: 2 }} isAnimationActive={false} />}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
